import { CountryDeliveriesDistributionPartWithReturns } from '@api/order-reporting/types-deliveries/CountryDeliveriesDistributionPart';



export type CountryDeliveriesSummaryReport = {
	country: string,
	executionPlace: string,
	executionPlaceName: string,
	transportTypesData: Record<MainTransportTypes, CountryDeliveriesDistributionPartWithReturns>,
}



export enum MainTransportTypes {
	sd = 'SD',
	td = 'TD',
	int = 'INT',
	dd = 'DD',
	total = 'Total',
}